<script>
import * as Units from '@/lib/units';
import Btn from "@/components/atoms/Btn";
import BtnRow from "@/components/atoms/BtnRow";
import Banner from "@/components/atoms/Banner";
import PartRow from "@/components/atoms/PartRow";
import SelectOption from '@/components/atoms/SelectOption.vue'
import PartTable from '@/components/atoms/PartTable.vue'
// import vendors from "@/data/parts/vendors.js";
import In from "@/components/atoms/In.vue";
import axios from 'axios';

export default {
  components: {Banner, Btn, BtnRow, PartRow, In, SelectOption, PartTable},
  props: ['showOptions'], 
  created(){
    this.$store.dispatch("saveFiles/loadSaveFiles", null, {root: true});
    this.$store.dispatch("saveFiles/loadPublicSaveFiles", null, {root: true});
  },
  mounted(){
    this.getImageURL();
    this.getGlbURL();
    this.getPartLedger();
    console.log(this.ledger);

    // const autocomplete = new google.maps.places.Autocomplete(this.$refs["origin"].$refs["origin"]);
    // autocomplete.addListener("place_changed", () => {
    //   const place = autocomplete.getPlace();
    //   this.address = place.formatted_address
    // })

    // this.email = this.$store.get('auth/user').email;
  },
  data(){
    return {
      order: null,
      ledger: null,
      image_url: null,
      glb_url: null,
      first_name: null,
      last_name: null,
      phone_number: null,
      // email: null,
      address: null,
      error: null,
      checkout: false,
      invoice_sent: false,
      downloading: null,
      creatingLink: null,
      fullscreen: false
    }
  },
  watch: {
    time(){
      this.getImageURL();
      this.getGlbURL();
      this.getPartLedger();
      setTimeout(() => {
        this.getImageURL();
        this.getGlbURL();
      }, 2000)
    },
  },
  computed: {
    // vendors(){
    //   return vendors;
    // },
    active(){
      if(this.saveFile){
        return this.$store.get('saveFiles/activeSaveFileId') == this.saveFile.id;
      }else{
        return false;
      }
    },
    isPublic(){
      return this.$route.matched.some(({ name }) => name === 'Template')
    },
    saveFile(){
      if(this.isPublic){
        return this.$store.get('saveFiles/publicSaveFilesById', this.$route.params.project_id)
      }else{
        return this.$store.get('saveFiles/saveFilesById', this.$route.params.project_id)
      }
    },
    partCount(){
      return this.$store.get('parts/getPartCountFromLedger', this.ledger)
    },
    selectedTotal(){
      let materialTotal = 0;
      let machiningTotal = 0;
      this.ledger.forEach(ledgerPart => {
        if(!ledgerPart.dontAddToOrder){
          let materialPrice = ledgerPart.materialPrice ? ledgerPart.materialPrice : 0;
          let machiningPrice = ledgerPart.machiningPrice ? ledgerPart.machiningPrice : 0;
          materialTotal += materialPrice * (ledgerPart.customQuantity ? ledgerPart.customQuantity : ledgerPart.quantity);
          machiningTotal += machiningPrice * (ledgerPart.customQuantity ? ledgerPart.customQuantity : ledgerPart.quantity);
        }
      })
      return Units.roundDollars(materialTotal + machiningTotal);
    },
    itemCount(){
      let count = 0;
      this.ledger.forEach(ledgerPart => {
        if(ledgerPart.materialPrice){
          count += Number((ledgerPart.customQuantity ? ledgerPart.customQuantity : ledgerPart.quantity))
        }
      })
      return count;
    },
    selectedItemCount(){
      let count = 0;
      this.ledger.forEach(ledgerPart => {
        if(!ledgerPart.dontAddToOrder && ledgerPart.materialPrice){
          count += Number((ledgerPart.customQuantity ? ledgerPart.customQuantity : ledgerPart.quantity));
        }
      })
      return count;
    },
    hasPanelBolts(){
      if(this.ledger){
        return this.ledger.some(ledgerPart => (
          ledgerPart.requiredMachining && ledgerPart.requiredMachining.some(rm => rm.machining == "DRILLHOLE")
        ))
      }else{
        return false;
      }
    },
    hasAccessHoles(){
      if(this.ledger){
        return this.ledger.some(ledgerPart => (
          ledgerPart.requiredMachining && ledgerPart.requiredMachining.some(rm => rm.machining == "ACCESSHOLE")
        ))
      }else{
        return false;
      }
    },
    time(){
      if(this.saveFile){
        return this.saveFile.time;
      }else{
        return "--";
      }
    },

    // total(){
    //   return this.$store.get('parts/getTotalFromLedger', {partLedger: this.partLedger, saveFile: this.saveFile})
    // }
  },
  methods: {
    getImageURL(){
      if(this.saveFile){
        if(this.isPublic){
          this.$store.dispatch("saveFiles/getPublicImage", this.saveFile.imageName).then(url => this.image_url = url);
        }else{
          this.$store.dispatch("saveFiles/getImage", this.saveFile.imageName).then(url => this.image_url = url);
        }
      }
    },
    getGlbURL(){
      if(this.saveFile){
        this.$store.dispatch("saveFiles/getGlb", this.saveFile.glbName).then(url => this.glb_url = url);
      }
    },
    getPartLedger(){
      if(this.saveFile){
        this.ledger = this.$store.get('saveFiles/getLedger', this.saveFile)
        this.$store.dispatch("payment/getOrderFromLedger", this.ledger).then(order => {
          this.order = order;
          this.order.projectId = this.$route.params.project_id;
          this.ledger = order.ledger;
        });
      }
    },
    blur(value){
      if(!value){
        this.$refs['origin'].$refs['origin'].value = null
      }else{
        this.$refs['origin'].$refs['origin'].value = this.address
      }
    },
    // validate(){
    //   if(!this.first_name || !this.last_name || !this.phone_number || !this.address){
    //     this.error = "*Missing required fields"
    //   }else{
    //     this.mixpanel.track('Request Invoice');
    //     this.$store.dispatch("payment/requestInvoice", {userID: this.$store.get('auth/user').uid, email: this.email, phone: this.phone, firstName: this.first_name, last_name: this.last_name, address: this.address, projectId: this.$route.params.project_id, saveFile: this.saveFile, total: this.total}).then(response => {
    //       this.mixpanel.track('Invoice Sent');
    //       this.error = null;
    //       this.invoice_sent = true;
    //       setTimeout(()=>{
    //         this.invoice_sent = false;
    //         this.checkout = false;
    //       }, 4000)
    //     }).catch(response => {
    //       console.log(response)
    //       this.mixpanel.track('Invoice Failed');
    //     })
    //   }
    // },
    startCheckout(){
      this.mixpanel.track('Checkout', {
        projectId: this.$route.params.project_id,
      });
      const filteredLedger = this.order.ledger.filter(part => !part.dontAddToOrder && part.materialPrice)
      if(this.$store.get('payment/pendingOrder')){
        this.$store.dispatch('payment/pendingOrder', {
          ...this.$store.get('payment/pendingOrder'),
          ...this.order,
          projectId: this.$route.params.project_id,
          imageUrl: this.image_url,
          ledger: [...this.$store.get('payment/pendingOrder').ledger, ...filteredLedger]
        });
      }else{
        this.$store.dispatch('payment/pendingOrder', {
          ...this.order,
          ledger: filteredLedger,
          projectId: this.$route.params.project_id,
          imageUrl: this.image_url,
        });
      }
      this.$router.push({name: 'Cart'})
    },
    highlightParts(ledgerPart){
      this.$store.dispatch("postMessage", "highlightParts:"+JSON.stringify(this.getSavedPartFromLedgerPart(ledgerPart)));
    },
    unhighlightParts(ledgerPart){
      this.$store.dispatch("postMessage", "unhighlightParts:"+JSON.stringify(this.getSavedPartFromLedgerPart(ledgerPart)));
    },
    getSavedPartFromLedgerPart(ledgerPart){
      return {
        parts: this.saveFile.parts.filter(savedPart => {
          const saveFileLedgerPart = this.$store.get('saveFiles/getLedgerPart', savedPart);
          return this.ledgerPartsAreEqual(saveFileLedgerPart, ledgerPart);
        })
      }
    },
    ledgerPartsAreEqual(a, b){
      return a.id == b.id && 
      a.length == b.length &&
      a.width == b.width &&
      a.height == b.height &&
      JSON.stringify(a.requiredMachining) == JSON.stringify(b.requiredMachining)
    },
    async exportGLB(){
      const modelViewer = document.getElementById("static-model");
      const glTF = await modelViewer.exportScene();
      const file = new File([glTF], this.saveFile.name+".glb");
      const link = document.createElement("a");
      link.download = file.name;
      link.href = URL.createObjectURL(file);
      link.click();
      this.mixpanel.track('Export File', {
        projectId: this.$route.params.project_id,
        projectName: this.saveFile.glbName,
        type: "glb",
      });
    },
    exportFile(type){
      if(this.downloading == null){
        this.downloading = setTimeout(() => {
          this.clearDownload();
        }, 10000);
        const user = this.$store.get("auth/user");
        if(user && user.uid){
          axios.post('https://us-central1-alloyxr.cloudfunctions.net/convert', {
            "data": {
              "uid": user.uid,
              "fileName": this.saveFile.glbName,
              "inputExtension": "glb",
              "outputExtension": type
            }
          }).then(response => {
            this.$store.dispatch("saveFiles/getFile", this.saveFile.glbName+"."+type).then(url => {
              const link = document.createElement("a");
              link.download = this.saveFile.name+"."+type;
              link.href = url;
              link.click();
              this.clearDownload();
            }).catch(error => {
              this.clearDownload();
              console.error(error);
            });
          }).catch(error => {
            this.clearDownload();
            console.error(error);
          });     
        }else{
          this.clearDownload();
          console.error("Unknown user tried to download step file.");
        }
      }
      this.mixpanel.track('Export File', {
        projectId: this.$route.params.project_id,
        projectName: this.saveFile.glbName,
        type: type,
      }); 
    },
    clearDownload(){
      clearTimeout(this.downloading);
      this.downloading = null;
    },
    setFullscreen(){
      this.fullscreen = !this.fullscreen
      if(this.fullscreen){
        document.body.style.overflow = 'hidden';
      }else{
        document.body.style.overflow = 'auto';
      }
    },
    loadProject(saveFile){
      this.$store.dispatch('saveFiles/loadFromCloud', saveFile);
    },
    copy3DModelLink(){
      console.log(`${this.$store.get('auth/user').uid}/PUBLIC/${this.saveFile.uid}.glb`);
      this.creatingLink = setTimeout(() => {
        this.clearCreatingLink();
      }, 10000);
      this.$store.dispatch('saveFiles/publicizeFile', {url: this.glb_url, name: this.saveFile.glbName}).then(path => {
        this.clearCreatingLink();
        const url = `https://quadrobee.web.app/#/viewer/${path}`;
        this.$store.commit('confirm', {
          title: "Copy Link Below",
          description: url,
          stop_label: "Close",
          start_label: "Copy URL",
          start: ()=>{
            try {
              navigator.clipboard.writeText(url);
              console.log("copied to clipboard");
            } catch (err) {
              console.error('Failed to copy to clipboard: ', err);
            }
          },
          stop: ()=>{}
        })
      }).catch(err => {
        this.clearCreatingLink();
        console.error(err)
      });
      this.mixpanel.track('Share Model Link', {
        projectId: this.$route.params.project_id,
        projectName: this.saveFile.glbName,
      }); 
    },
    clearCreatingLink(){
      clearTimeout(this.creatingLink);
      this.creatingLink = null;
    },
    nonMobileARView(){
      this.$toast("Augmented reality is only available on mobile devices.", {
        type: "success",
      });
    },
    photograph(){      
      if(this.downloading == null){
        this.downloading = setTimeout(() => {
          this.clearDownload();
        }, 10000);
        const user = this.$store.get("auth/user");
        if(user && user.uid){
          axios.post('https://us-central1-alloyxr.cloudfunctions.net/photograph', {
            "data": {
              "uid": user.uid,
              "fileName": this.saveFile.glbName,
            }
          }).then(response => {
            this.$store.dispatch("saveFiles/getFile", this.saveFile.glbName+".png").then(url => {
              const link = document.createElement("a");
              link.download = this.saveFile.name+".png";
              link.href = url;
              link.click();
              this.clearDownload();
            }).catch(error => {
              this.clearDownload();
              console.error(error);
            });
          }).catch(error => {
            this.clearDownload();
            console.error(error);
          });     
        }else{
          this.clearDownload();
          console.error("Unknown user tried to download step file.");
        }
      }
      // this.mixpanel.track('Export File', {
      //   projectId: this.$route.params.project_id,
      //   projectName: this.saveFile.glbName,
      //   type: type,
      // }); 
    },
  }
  
}
</script>

<template>
  <Banner>
    <div class="project" :class="{fullscreen}">
      <transition name="fade-loading">
        <div class="overlay" v-if="invoice_sent" >
          <div class="module saved">
            <i class="fas fa-paper-plane"></i>
            <div class="saved">
              Request Sent
            </div>
            <div class="sub-text">
              Check your email. You should receive and invoice within the next 24 hours.
            </div>
          </div>
        </div>
      </transition>
      <div class="project-module">
        <div class="back-row">
          <btn size="large" color="secondary" @click="$router.go(-1)"><i class="fas fa-caret-left"></i> Back</btn>
          <btn v-if="$store.get('vr')" type="fill"  size="medium" @click="() => loadProject(saveFile)">Load Project</btn>
        </div>
        <div class="main-row" v-if="saveFile">
          <div class="image-col" :class="{'selected': $store.get('saveFiles/activeSaveFileId') == saveFile.id}" >
            <img class="image" :src="image_url" />
          </div>
          <div class="detail-col">
            <div v-if="isPublic" class="project-public">
              Template
            </div>
            <div class="project-title">
              {{saveFile.name}}
            </div>
            <div class="project-id" v-if="false">
              {{saveFile.id}}
            </div>
            <div class="project-details">
              <div class="detail">
                <div class="label">
                  Last Updated
                </div>
                <div class="value">
                  {{new Date(saveFile.time+' UTC').toLocaleString()}}
                </div>
              </div>
              <div class="detail">
                <div class="label">
                  Parts
                </div>
                <div class="value">
                  {{partCount}}
                </div>
              </div>
            </div>
            <!-- <div class="btn-container">
              <btn type="fill" color="secondary" >Share Project</btn>
              <btn type="fill" color="secondary">Share List</btn>
            </div> -->
          </div>
        </div>
        <div class="controls" v-if="glb_url && !$store.get('vr')">          
          <div class="left control-group">
            <select-option :options="['3D Model']" location="right" @3d-model="copy3DModelLink">
              <btn size="medium" type="fill" :loading="creatingLink"><span class="fa fa-share"></span>Share</btn>
            </select-option>
            <select-option location="right" :options="['STEP', '', 'FBX', 'GLB', '', 'DXF', 'IFC', 'IGES', 'OBJ', 'U3D', 'USD']" @step="() => exportFile('step')" @pdf="() => exportFile('pdf')" @ifc="() => exportFile('ifc')" @iges="() => exportFile('iges')" @dxf="() => exportFile('dxf')" @glb="exportGLB" @fbx="() => exportFile('fbx')" @obj="() => exportFile('obj')" @stl="() => exportFile('stl')" @u3d="() => exportFile('u3d')" @usd="() => exportFile('usd')">
              <btn size="medium" type="fill" :loading="downloading"><span class="fa fa-download"></span>Export</btn>
            </select-option>
          </div>
          <div class="right control-group"></div>
        </div>
        <!-- environment-image="shared-assets/environments/moon_1k.hdr" poster="shared-assets/models/NeilArmstrong.webp" -->
        <div v-if="glb_url && !$store.get('vr')" class="viewer-3d" :class="{fullscreen, mobile: $store.get('usingMobile')}">
          <model-viewer id="static-model" alt="Quadrobee Project" :src="glb_url" ar shadow-intensity="1" camera-controls>
            <btn slot="ar-button" class="ar-view" size="medium" type="fill" color="secondary"><span class="fa fa-vr-cardboard"></span>AR</btn>
            <btn v-if="!$store.get('usingMobile')" class="ar-view" size="medium" type="fill" color="secondary" @click="nonMobileARView"><span class="fa fa-vr-cardboard"></span>AR</btn>
          </model-viewer>
          <span class="expand fa" :class="{'fa-expand': !fullscreen, 'fa-compress': fullscreen}" @click="setFullscreen"></span>
        </div>
        <div class="resave-prompt" v-if="!glb_url && !$store.get('vr')">
          <div class="sub-propt">
            3D Model Not Found
          </div>
          <div class="propt">
            Please resave your project.
          </div>
        </div>
        <div class="login-prompt" v-if="$store.get('vr')">
          <div class="icons">
            <img :src="'./images/devices.png'" />
            <!-- <span class="fa fa-laptop"></span>
            <span class="fa fa-mobile-alt"></span> -->
          </div>
          <div class="website">
            <div class="propt">
              Quadrobee.com
            </div>
          </div>
          <div class="features">
            <div class="bullet">
              • 3D Viewer
            </div>
            <div class="bullet">
              • Mobile AR
            </div>
            <div class="bullet">
              • Exporting
            </div>
            <div class="bullet">
              • Fast Checkout
            </div>
          </div>
        </div>
        <!-- <div class="vendor-select">
          <div v-for="(vendor, index) in Object.keys(vendors)" :key="index" class="vendor" :class="{selected: $store.state.selectedVendor == vendor}" @click="$store.commit('selectedVendor', vendor)">
            {{vendors[vendor].name}}
          </div>
        </div> -->
        <div class="warnings">
          <div class="panel-warning info" v-if="hasPanelBolts">
            <span class="fa fa-exclamation-triangle"></span>
            WARNING: You will need to drill your own panel holes. Please contact Support@quadrobee.com to place a custom order.
          </div>
          <div class="panel-warning info" v-if="hasAccessHoles">
            <span class="fa fa-exclamation-triangle"></span>
            WARNING: You will need to drill your own access holes. Please contact Support@quadrobee.com to place a custom order.
          </div>
          <div class="panel-warning info" v-if="false">
            <span class="fa fa-exclamation-triangle"></span>
            WARNING: Quadrobee is still in Beta. Please double-check your parts, dimensions, and machining services before placing an order.
          </div>
        </div>
        <div class="parts-row" v-if="saveFile">
          <PartTable>
            <div class="headers row">
              <div class="item-col">Items</div>
              <div class="quantity-col">Qty</div>
              <div class="price-col">Price</div>
              <div class="total-price-col">Total</div>
            </div>
            <div v-if="ledger">
              <PartRow v-for="(ledgerPart, index) in ledger" :key="index" :ledgerPart="ledgerPart" :index="index" ref="part" :number="index" :show-select="true" :highlight="$store.get('saveFiles/activeSaveFileId') == saveFile.id" @highlightparts="highlightParts" @unhighlightparts="unhighlightParts"></PartRow>
            </div>
          </PartTable>
        </div>
      </div>
      <div class="checkout-area" v-if="order" :class="{mobile: $store.get('usingMobile')}">
        <div class="checkout">
          <div class="left">
            {{selectedItemCount}} / {{itemCount}}
          </div>
          <div class="right">
            <div class="total">
              <span class="text">est. Total </span><span class="price">${{selectedTotal}}</span>
            </div>
            <div class="purchase" v-show="!checkout">
              <btn type="fill" @click="startCheckout()">Add to Cart</btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
.project{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: $black_2;
  flex: 1;
  .project-module{
    flex-basis: 80rem;
    margin: 1.5rem;
    margin-bottom: 6rem;
    .back-row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2rem;
      .button{
        &.large{
          font-size: 1.5rem;
        }
      }
      i{
        padding-right: 0.5rem;
      }
    }
    .main-row{
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      .image-col{
        width: 20rem;
        // border: 2px solid $black_3;
        border-radius: 6px;
        margin-right: 4rem;
        margin-bottom: 2rem;
        &.selected{
          border: 4px solid $p;
        }
        img{
          width: 100%;
          filter: brightness(2.5);
        }
      }
      .detail-col{
        flex: 1;
        margin-bottom: 2rem;
        .project-public{
          font-size: 1.5rem;
          color: $p;
          margin-bottom: 0.25rem;
        }
        .project-title{
          font-size: 2rem;
          margin-bottom: 1.25rem;
        }
        .project-id{
          margin-bottom: 1.5rem;
          color: $w_1;
        }
        .project-details { 
          // display: flex;
          // flex-wrap: wrap;
          // align-items: center;
          .detail { 
            margin: 0rem 0rem 1.5rem 0rem;
            .label { 
              font-size: 1.25rem;
              margin-bottom: 0.5rem;
              color: #CCC;
            }
            .value { 
              font-size: 1.5rem;
              color: #FFF;
            }
          }
        }
        .btn-container{
          display: flex;
          align-items: center;
          justify-content: stretch;
          margin-top: 1rem;
          .button{
            flex: 1;
            &:nth-child(2) {
              margin-left: 1rem;
            }
          }
        }
      }
    }

    .controls{
      flex-basis: 100%;
      // position: absolute;
      // top: 1rem;
      // right: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 0rem;
      .control-group{
        display: flex;
        align-items: center;
        .select-container{
          z-index: 1;
        }
      }
      .left{
        .button{
          margin-right: 1rem;
        }
      }
      .right{
        .button{
          margin-left: 1rem;
        }
      }
    }
    .viewer-3d{
      flex-basis: 100%;
      background-color: $black_1_2;
      position: relative;
      &.mobile{
        model-viewer{
          height: 18rem;  
        }
      }
      &.fullscreen{
        position: fixed;
        top: 0rem;
        left: 0rem;
        width: 100dvw;
        height: 100dvh;
        z-index: 1000;
        model-viewer{
          height: 100%;
          .ar-view{
            position: absolute;
            bottom: 1.5rem;
            right: 1.5rem;
          }
        }
        .expand{
          top: 1rem;
          right: 1rem;  
        }
      }
      model-viewer{
        width: 100%;
        height: 35rem;
        border: 2px solid $black_3;
        border-radius: 2px;
        .ar-view{
          position: absolute;
          bottom: 1rem;
          right: 1rem;
        }
      }
      .expand{
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        font-size: 1.75rem;
        padding: 0.75rem;
        &:hover{
          color: $w_1;
        }
      }
    }
    .resave-prompt{
      background-color: $black_1_2;
      width: 100%;
      height: 15rem;
      border: 2px solid $black_3;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .sub-propt { 
          font-size: 1rem;
        }
        .propt { 
          font-size: 1.5rem;
          padding: 0.5rem;
        }
    }
    .login-prompt { 
      width: 100%;
      height: 24rem;
      border: 2px solid $black_3;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-color: $black_1_2;
      .features { 
        // width: 33%;
        // padding: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .bullet { 
          // color: $w_1;
          font-size: 1.25rem;
          padding: 0.5rem;
        }
      }
      .website { 
        // width: 33%;
        padding-bottom: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .sub-propt { 
          font-size: 1.25rem;
        }
        .propt { 
          font-size: 2rem;
          // padding: 0.25rem;
        }
      }
      .icons { 
        // width: 33%;
        // height: 100%;
        // padding: 0rem;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        .fa { 
          font-size: 3rem;
          margin: 0rem 0.5rem;
          color: $w_1;
        }
        img{
          height: 13rem;
        }
      }
    }

    .warnings{
      .panel-warning{
        margin: 0.5rem 0rem;
        border-radius: 4px;
        padding: 1rem 2rem;
        font-size: 1.25rem;
        .fa{
          font-size: 1.125rem;
        }
        &.warning{
          background-color: $black_4;
        }
        &.info{
          background-color: $black_3;
        }
      }
    }
    
    .vendor-select{
      display: flex;
      align-items: center;
      .vendor{
        padding: 0.5rem;
        margin-right: 1rem;
        font-size: 1.5rem;
        color: $w_1;
        border-bottom: 0.25rem solid $black_1;
        &.selected{
          color: $w;
          border-color: $w;
        }
        &:hover, &.hover{
          cursor: pointer;
        }
      }
    }
  }
  .checkout-area{
    position: fixed;
    bottom: 0rem;
    left: 0rem;
    width: 100%;
    border-top: 2px solid $black_2;
    background-color: $black_1;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
    &.mobile{
      position: relative;
      .checkout{
        flex-wrap: wrap;
        .left{
          margin-left: 0rem;
        }
        .right{
          flex-wrap: wrap;
          .total{
            padding-left: 0rem;
            padding-bottom: 1rem;
          }
          .purchase {
            flex: 1;
            .button{
              flex: 1;
            }
          }
        }
      }
    }
    .checkout{
      z-index: 100;
      display: flex;
      align-items: center;
      flex-basis: 80rem;
      justify-content: space-between;
      padding: 1.5rem 2rem;
      .left, .right{
        display: flex;
        align-items: center;
      }
      .left{
        margin-left: 1rem;
        font-size: 1.5rem;
      }
      .total{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 1.5rem;
        padding: 0rem 2rem;
        .text{
          margin-right: 1rem;
          color: $w_1;
        }
        .price{
          
        }
      }
      .purchase{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .button{
          width: 20rem;
        }
      }
      .checkout-module{
        flex-basis: 80rem;
        padding: 2rem;
        .input-row{
          display: flex;
          align-items: center;
          .input{
            padding: 0.5rem;
            flex: 1;
          }
        }
        .error-row{
          color: $error;
          padding: 0.5rem;
        }
        .button-row{
          padding: 0.5rem;
        }
      }
    }
  }
  .overlay{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    .module{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 5rem 6rem;
      border-radius: 0.5rem;
      &.saving{
        background-color: #444;
      }
      &.saved{
        background-color: #48c586;
      }
      .press{
        width: 15rem;
        margin-bottom: 4rem;
      }
      .text{
        font-size: 2rem;
        margin-bottom: 1.5rem;
      }
      .sub-text{
        font-size: 1.25rem;
        max-width: 30rem;
        text-align: center;
      }
      .fas{
        font-size: 3rem;
        margin-bottom: 1.5rem;
        // color: #64f7ad;
      }
      .saved{
        font-size: 2rem;
        margin-bottom: 0.5rem;
        // color: #64f7ad;
      }
    }
  }
  .fade-loading-enter-active{
    transition: all 0.4s;
  }
  .fade-loading-leave-active{
    transition: all 0.2s;
  }
  .fade-loading-enter{
    opacity: 0;
  }
  .fade-loading-leave-to{
    opacity: 0;
  }
}
</style>